<div>
  <div class="d-flex justify-content-end gap-3">
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <form class="easy-form gap-3" [formGroup]="form">
    <legend>{{ "VIP_DISCOUNTS.PARTNERS.SEARCH_TEXT" | translate }}</legend>
    <mat-form-field>
      <app-easy-input
        [formControlName]="'searchText'"
        [iconSuffix]="'search'"
      ></app-easy-input>
    </mat-form-field>
  </form>
</div>

<div class="checkbox-btns-container d-flex align-items-center gap-4 my-3">
  <mat-checkbox
    class="easy-checkbox"
    (change)="$event ? partnersTableSource.toggleAllRows() : null"
    [checked]="
      partnersTableSource.selection.hasValue() &&
      partnersTableSource.isAllSelected()
    "
    [indeterminate]="
      partnersTableSource.selection.hasValue() &&
      !partnersTableSource.isAllSelected()
    "
    [aria-label]="checkboxLabel()"
    [disabled]="!partnersTableSource.data.length"
  >
  </mat-checkbox>
  <div class="selection-container me-4">
    {{
      partnersTableSource.selection.selected.length +
        ("SHARED.PIECES" | translate)
    }}
    {{ "SHARED.SELECTED" | translate }}
  </div>
</div>
<div class="table-container">
  <table
    class="data-table"
    mat-table
    [dataSource]="partnersTableSource"
    matSort
    #partnersTable
  >
    <app-checkable-column
      [hideCheckboxInHeader]="true"
      [tableRef]="partnersTable"
    >
    </app-checkable-column>

    <ng-container matColumnDef="companyName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ "VIP_DISCOUNTS.PARTNERS.TABLE.COMPANY_NAME" | translate }}
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element.companyName }}
      </td>
    </ng-container>

    <ng-container matColumnDef="brandName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ "VIP_DISCOUNTS.PARTNERS.TABLE.BRAND_NAME" | translate }}
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element.brandName }}
      </td>
    </ng-container>

    <tr
      mat-header-row
      *matHeaderRowDef="partnersTableSource.displayedColumns; sticky: true"
    ></tr>
    <tr
      mat-row
      *matRowDef="
        let row;
        let idx = index;
        columns: partnersTableSource.displayedColumns
      "
    ></tr>
  </table>
</div>

<mat-paginator
  [pageSizeOptions]="pageSizeOptions"
  [pageSize]="pageSizeOptions[0]"
  [length]="(totalPartnersResult$ | async) ?? 0"
  showFirstLastButtons
>
</mat-paginator>

<div class="d-flex justify-content-end gap-4 mt-4">
  <button mat-button mat-stroked-button color="primary" mat-dialog-close>
    {{ "DIALOG.CANCEL" | translate }}
  </button>
  <button
    mat-button
    mat-raised-button
    color="primary"
    [mat-dialog-close]="true"
    (click)="selectPartners()"
  >
    {{ "VIP_DISCOUNTS.PARTNERS.SELECT_PARTNER_BTN" | translate }}
  </button>
</div>
